// Complete Simplified productScript.js with Bundle Support and SKU-based Stock Checking
// This is called on the product page, and also inside quickview.js
window.initProductScript = function (
    product,
    selectorID,
    scope,
    initUpsellVariantSync = true,
    isUpsellProduct = false
) {
    // Ensure Shopify scripts are loaded before proceeding
    function waitForShopify(callback, maxAttempts = 10) {
        let attempts = 0
        const checkShopify = () => {
            attempts++
            if (typeof Shopify !== 'undefined' && Shopify.OptionSelectors) {
                callback()
            } else if (attempts < maxAttempts) {
                setTimeout(checkShopify, 200)
            } else {
                // console.error(
                //     'Shopify.OptionSelectors failed to load after multiple attempts'
                // )
            }
        }
        checkShopify()
    }
    const closestSection = scope.closest('section')
    let currentVariant
    window.sliders = []
    window.mobileSliders = []
    window.newSwiper = function (el, options) {
        return new Swiper(el, options)
    }

    // Shared utility functions
    function _slugify(string) {
        return string.toLowerCase().replace(/\s+/g, '-').trim()
    }

    function createSizeSelectHTML(selectBox, labelText) {
        return `<div class="flex flex-col gap-2">
            <label class="uppercase" style="font-family: 'Anton', sans-serif !important; margin-bottom: 0 !important;">${labelText} </label>
            <div style="display: flex; gap: 1rem; flex-wrap: wrap;">
                <div style="position: relative; width: max-content;">
                    <svg style="position: absolute; left: 0.75rem; top: 50%; transform: translateY(-50%); pointer-events: none; z-index: 20;" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="7.27055" cy="6.78654" r="6.61454" fill="#00AEEF"/>
<path d="M6.48738 7.50905L9.54027 4.66185C9.81763 4.40318 10.2673 4.40314 10.5447 4.66185C10.8221 4.92056 10.8221 5.33998 10.5447 5.59865L6.98962 8.91425C6.71219 9.17299 6.26248 9.17289 5.98515 8.91425L4.00016 7.06297C3.72277 6.80426 3.72277 6.38485 4.00016 6.12617C4.27756 5.8675 4.72726 5.86746 5.00462 6.12617L6.48738 7.50905Z" fill="white"/>
</svg>
                    <select id="${selectBox.id}" name="${selectBox.name}" style="border: 1px solid #d1d5db; border-radius: 0.375rem; padding: 0.5rem 2rem; padding-left: 2.5rem; font-size: 0.811rem; width: 100%; display: block; margin-bottom: 0 !important;">
                    <option value="" disabled>Choose your size</option>
                        ${selectBox.innerHTML}
                    </select>
                </div>
                <a href="#" class="flex gap-1 items-center ml-2 text-sm font-normal leading-normal underline uppercase cursor-pointer shrink-0 size-guide-link text-neutral-700 hover:text-[#00AEEF]">
                    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_3259_27407)"><path d="M8 14.7866C11.3137 14.7866 14 12.1003 14 8.78656C14 5.47285 11.3137 2.78656 8 2.78656C4.68629 2.78656 2 5.47285 2 8.78656C2 12.1003 4.68629 14.7866 8 14.7866Z" stroke="#404040" stroke-linecap="round" stroke-linejoin="round"/><path d="M7.5 8.28656C7.63261 8.28656 7.75979 8.33924 7.85355 8.33301C7.94732 8.52677 8 8.65395 8 8.78656V11.2866C8 11.4192 8.05268 11.5463 8.14645 11.6401C8.24021 11.7339 8.36739 11.7866 8.5 11.7866" stroke="#404040" stroke-linecap="round" stroke-linejoin="round"/><path d="M7.75 6.78656C8.16421 6.78656 8.5 6.45077 8.5 6.03656C8.5 5.62235 8.16421 5.28656 7.75 5.28656C7.33579 5.28656 7 5.62235 7 6.03656C7 6.45077 7.33579 6.78656 7.75 6.78656Z" fill="#404040"/></g><defs><clipPath id="clip0_3259_27407"><rect width="16" height="16" fill="white" transform="translate(0 0.78656)"/></clipPath></defs></svg> 
                    See sizing guide
                </a>
            </div>
        </div>`
    }

    // Create simplified size select HTML for bundles (no inventory tracking)
    function createSimplifiedSizeSelectHTML(selectBox, labelText) {
        return `<div class="flex flex-col gap-2">
            <label class="uppercase" style="font-family: 'Anton', sans-serif !important; margin-bottom: 0 !important;">${labelText}</label>
            <div style="display: flex; gap: 1rem; flex-wrap: wrap;">
                <div style="position: relative; width: max-content;">
                    <svg style="position: absolute; left: 0.75rem; top: 50%; transform: translateY(-50%); pointer-events: none; z-index: 20;" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="7.27055" cy="6.78654" r="6.61454" fill="#00AEEF"/>
                        <path d="M6.48738 7.50905L9.54027 4.66185C9.81763 4.40318 10.2673 4.40314 10.5447 4.66185C10.8221 4.92056 10.8221 5.33998 10.5447 5.59865L6.98962 8.91425C6.71219 9.17299 6.26248 9.17289 5.98515 8.91425L4.00016 7.06297C3.72277 6.80426 3.72277 6.38485 4.00016 6.12617C4.27756 5.8675 4.72726 5.86746 5.00462 6.12617L6.48738 7.50905Z" fill="white"/>
                    </svg>
                    <select 
                        id="${selectBox.id}" 
                        name="${selectBox.name}" 
                        style="border: 1px solid #d1d5db; border-radius: 0.375rem; padding: 0.5rem 2rem; padding-left: 2.5rem; font-size: 0.811rem; width: 100%; display: block; margin-bottom: 0 !important;">
                        <option value="" disabled>Choose your size</option>
                        ${selectBox.innerHTML}
                    </select>
                </div>
                <a href="#" class="flex gap-1 items-center ml-2 text-sm font-normal leading-normal underline uppercase cursor-pointer shrink-0 size-guide-link text-neutral-700 hover:text-[#00AEEF]">
                    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_3259_27407)">
                            <path d="M8 14.7866C11.3137 14.7866 14 12.1003 14 8.78656C14 5.47285 11.3137 2.78656 8 2.78656C4.68629 2.78656 2 5.47285 2 8.78656C2 12.1003 4.68629 14.7866 8 14.7866Z" stroke="#404040" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M7.5 8.28656C7.63261 8.28656 7.75979 8.33924 7.85355 8.33301C7.94732 8.52677 8 8.65395 8 8.78656V11.2866C8 11.4192 8.05268 11.5463 8.14645 11.6401C8.24021 11.7339 8.36739 11.7866 8.5 11.7866" stroke="#404040" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M7.75 6.78656C8.16421 6.78656 8.5 6.45077 8.5 6.03656C8.5 5.62235 8.16421 5.28656 7.75 5.28656C7.33579 5.28656 7 5.62235 7 6.03656C7 6.45077 7.33579 6.78656 7.75 6.78656Z" fill="#404040"/>
                        </g>
                        <defs><clipPath id="clip0_3259_27407"><rect width="16" height="16" fill="white" transform="translate(0 0.78656)"/></clipPath></defs>
                    </svg> 
                    See sizing guide
                </a>
            </div>
        </div>`
    }

    function attachSizeGuideListeners(container) {
        const sizeGuideLinks = container.querySelectorAll('.size-guide-link')
        sizeGuideLinks.forEach((link) => {
            link.addEventListener('click', function (e) {
                e.preventDefault()
                var sizeGuideModal = document.getElementById('size-guide-modal')
                if (sizeGuideModal) {
                    if (typeof sizeGuideModal.showModal === 'function') {
                        sizeGuideModal.showModal()
                    } else {
                        sizeGuideModal.setAttribute('open', '')
                    }
                }
            })
        })
    }

    function updateRadioCheckedStyles(radioSelector) {
        let radioInputs = radioSelector.querySelectorAll('input[type="radio"]')
        radioInputs.forEach((radioInput) => {
            let label = radioInput.nextElementSibling
            if (label && label.classList.contains('variant-label')) {
                if (radioInput.checked) {
                    label.style.borderColor = '#00aeef'
                    label.style.boxShadow =
                        '0px 8.5px 26px 0px rgba(0,0,0,0.15)'
                } else {
                    label.style.borderColor = '#D9D9D9'
                    label.style.boxShadow = 'none'
                }
            }
        })
    }

    /**
     *
     * Removes disabled attributes on variant selectors
     *
     */
    function removeDisabledAttribute(els) {
        console.log('els: ', els)
        els.forEach(function (el, index) {
            el.classList.remove('disabled')

            // Restore original button functionality if we have stored data
            el.textContent = window.inventory_text.add_to_cart
            el.type = 'submit' // Always set to submit for in-stock
            el.removeAttribute('disabled')
            // Replace the button with a clone to remove all event listeners
            const clone = el.cloneNode(true)
            el.parentNode.replaceChild(clone, el)
        })
    }

    /**
     *
     * Adds disabled attributes to variant selectors
     *
     */
    function addDisabledAttribute(els) {
        els.forEach(function (el, index) {
            // el.classList.add('disabled')
            el.textContent = 'Notify me when available'
            el.removeAttribute('disabled')
            el.type = 'button' // Change from submit to button to prevent form submission

            // Store original properties if not already stored
            if (!el.dataset.originalText) {
                el.dataset.originalText = el.textContent
                el.dataset.originalOnclick = el.onclick
                el.dataset.originalType = el.type
                el.dataset.originalDisabled = el.disabled
            }

            // Remove any existing click handlers
            el.onclick = null

            // Add new click handler for back-in-stock modal
            el.addEventListener('click', function (e) {
                e.preventDefault()
                e.stopPropagation()

                // console.log('Add button clicked, showing back-in-stock modal')

                // Show our custom back-in-stock modal
                if (
                    window.BackInStockModal &&
                    typeof window.BackInStockModal.show === 'function'
                ) {
                    // Get current variant information
                    const variantInfo = currentVariant
                        ? {
                            title: currentVariant.title,
                            name: currentVariant.name,
                            id: currentVariant.id,
                        }
                        : null

                    window.BackInStockModal.show(variantInfo)
                    // console.log('Back-in-stock modal shown successfully')
                } else {
                    console.error('BackInStockModal not available')
                    alert(
                        'Please contact us to be notified when this item is back in stock.'
                    )
                }
            })
        })
    }

    /**
     *
     * Updates the "id" input values on elements across the page
     * Intention is to handle add to cart buttons further down the page than the hero
     * And also the sticky add to cart bar
     *
     */
    function _updateIDInput(els, variant) {
        // console.log(
        //     '🔄 _updateIDInput called with variant:',
        //     variant ? variant.id : null
        // )
        els.forEach(function (el, index) {
            let thisForm = el.closest('form')
            let thisIDInput = thisForm.querySelector('[name="id"]')

            if (thisForm) {
                thisIDInput = thisForm.querySelector('[name="id"]')
            }

            if (thisIDInput) {
                // console.log(
                //     `📝 Updating form ${index} variant ID from ${thisIDInput.value} to ${variant.id}`
                // )
                thisIDInput.value = variant.id
            } else {
                // console.warn(`⚠️ No ID input found in form ${index}`)
            }
        })
    }

    /**
     *
     * Updates flashing stock indicator in product hero
     *
     */
    function _stockIndicator(el, stockStatus, stockCount = null) {
        if (!el) return

        let statusMessages = {
            instock: inventory_text.in_stock_long,
            lowstock: inventory_text.low_stock_long,
            outofstock: inventory_text.sold_out_long,
        }

        // Remove all status classes
        el.classList.remove('instock', 'lowstock', 'outofstock')

        // Remove all color classes
        el.classList.remove(
            'text-green-500',
            '!text-yellow-500',
            'text-yellow-500',
            '!text-red-500',
            'text-red-500',
            'text-gray-500'
        )

        if (stockStatus) {
            el.classList.add(stockStatus)

            // Set color based on status
            let textColor = ''
            if (stockStatus === 'instock') {
                textColor = '#10B981' // green-500
            } else if (stockStatus === 'lowstock') {
                textColor = '#EAB308' // yellow-500
            } else if (stockStatus === 'outofstock') {
                textColor = '#EF4444' // red-500
            }

            el.style.color = textColor

            // Create the dot element
            const dot = document.createElement('div')
            dot.style.width = '0.8125rem'
            dot.style.height = '0.8125rem'
            dot.style.backgroundColor = textColor
            dot.style.borderRadius = '50%'
            dot.classList.add('fade-indicator')

            // Add the animated spans
            dot.innerHTML = `
                <span style="--i:0;"></span>
                <span style="--i:1;"></span>
                <span style="--i:2;"></span>
                <span style="--i:3;"></span>
            `

            // Clear existing content and add dot + text
            el.innerHTML = ''
            el.appendChild(dot)

            // Add the text content
            const textNode = document.createTextNode(
                stockStatus === 'lowstock' && stockCount !== null
                    ? statusMessages[stockStatus]
                        .replace('{{ count }}', stockCount)
                        .replace('{{ quantity }}', stockCount)
                    : statusMessages[stockStatus]
            )

            console.log('textNode: ', textNode)
            el.appendChild(textNode)
        } else {
            // No stock status - add gray color for "no tracking" case
            const textColor = '#6B7280' // gray-500
            el.style.color = textColor

            // Create the dot element for no tracking case
            const dot = document.createElement('div')
            dot.style.width = '0.8125rem'
            dot.style.height = '0.8125rem'
            dot.style.backgroundColor = textColor
            dot.style.borderRadius = '50%'
            dot.classList.add('fade-indicator')

            // Add the animated spans
            dot.innerHTML = `
                <span style="--i:0;"></span>
                <span style="--i:1;"></span>
                <span style="--i:2;"></span>
                <span style="--i:3;"></span>
            `

            // Clear existing content and add dot + text
            el.innerHTML = ''
            el.appendChild(dot)

            // Add the text content
            const textNode = document.createTextNode(statusMessages.instock)
            el.appendChild(textNode)
        }
    }

    // SKU-based Bundle Stock Checking functionality
    window.BundleStockChecker = {
        endpoint: 'https://blumaka-prod-endpoint.netlify.app/.netlify/functions/check-bundle-stock',
        isChecking: false,
        lastCheckId: null,

        // Check stock for bundle by sending raw properties
        async checkBundleStock(properties) {
            // Prevent multiple simultaneous requests
            if (this.isChecking) {
                return { available: true }; // Return optimistic result
            }

            // Generate unique check ID to handle race conditions
            const checkId = Date.now() + Math.random();
            this.lastCheckId = checkId;
            this.isChecking = true;

            try {
                const response = await fetch(this.endpoint, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        properties: properties,
                        shopDomain: window.Shopify?.shop || '',
                        bundleProductId: this.getBundleProductId() // Get the main bundle product ID
                    })
                });

                const result = await response.json();

                // Check if this is still the latest request
                if (checkId !== this.lastCheckId) {
                    return { available: true }; // Ignore outdated responses
                }

                return result;

            } catch (error) {
                console.error('Stock check failed:', error);
                // Return optimistic result on error to avoid blocking customers
                return {
                    available: true,
                    error: true,
                    message: 'Stock check temporarily unavailable'
                };
            } finally {
                this.isChecking = false;
            }
        },

        // Get current bundle properties from DOM
        getBundleProperties() {
            const properties = {};

            // Get all property inputs from the bundle
            const propertyInputs = document.querySelectorAll('input[name^="properties["]');

            propertyInputs.forEach(input => {
                if (input.name && input.value && !input.name.includes('_bundle_selection')) {
                    // Extract property name from input name
                    const match = input.name.match(/properties\[(.+?)\]/);
                    if (match) {
                        const propertyKey = match[1];
                        properties[propertyKey] = input.value;
                    }
                }
            });

            return properties;
        },

        // Get the main bundle product ID
        getBundleProductId() {
            const idInput = document.querySelector('form#add-to-cart input[name="id"]');
            return idInput ? idInput.value : null;
        },

        // Update UI based on stock check result
        updateStockUI(result) {
            const stockIndicator = document.querySelector('.stock-indicator');
            const addToCartButtons = document.querySelectorAll('button[name="add"]');

            if (result.available) {
                // Items in stock
                if (stockIndicator) {
                    _stockIndicator(stockIndicator, 'instock');
                }

                addToCartButtons.forEach(btn => {
                    btn.disabled = false;
                    btn.textContent = window.inventory_text?.add_to_cart || 'Add to Cart';
                    btn.style.opacity = '1';
                    btn.style.cursor = 'pointer';
                });

                // Remove any error messages
                this.removeStockErrorMessage();

            } else {
                // Some items out of stock
                if (stockIndicator) {
                    _stockIndicator(stockIndicator, 'outofstock');
                }

                addToCartButtons.forEach(btn => {
                    btn.disabled = true;
                    btn.textContent = 'Unavailable - Check Options';
                    btn.style.opacity = '0.6';
                    btn.style.cursor = 'not-allowed';
                });

                // Show error message
                this.showStockErrorMessage(result.message || 'Some items are currently out of stock');
            }
        },

        // Show stock error message
        showStockErrorMessage(message) {
            this.removeStockErrorMessage(); // Remove existing message

            const errorDiv = document.createElement('div');
            errorDiv.className = 'bundle-stock-error';
            errorDiv.style.cssText = `
                background-color: #fef2f2;
                border: 1px solid #fecaca;
                color: #dc2626;
                padding: 0.75rem;
                border-radius: 0.375rem;
                margin: 1rem 0;
                font-size: 0.875rem;
            `;
            errorDiv.innerHTML = `
                <div style="display: flex; align-items: center; gap: 0.5rem;">
                    <svg width="16" height="16" viewBox="0 0 20 20" fill="currentColor">
                        <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clip-rule="evenodd" />
                    </svg>
                    <span>${message}</span>
                </div>
            `;

            // Insert after bundle options
            const bundleOptions = document.querySelector('.simple-bundle-options-radio');
            if (bundleOptions) {
                bundleOptions.appendChild(errorDiv);
            }
        },

        // Remove stock error message
        removeStockErrorMessage() {
            const existingError = document.querySelector('.bundle-stock-error');
            if (existingError) {
                existingError.remove();
            }
        },

        // Show loading state
        showLoadingState() {
            const addToCartButtons = document.querySelectorAll('button[name="add"]');
            addToCartButtons.forEach(btn => {
                btn.disabled = true;
                btn.textContent = 'Checking availability...';
                btn.style.opacity = '0.7';
            });
        },

        // Debounced stock check to avoid too many API calls
        debouncedCheck: null,
        debounceStockCheck(delay = 500) {
            clearTimeout(this.debouncedCheck);
            this.debouncedCheck = setTimeout(async () => {
                const properties = this.getBundleProperties();

                if (Object.keys(properties).length === 0) {
                    return; // No properties selected yet
                }

                this.showLoadingState();
                const result = await this.checkBundleStock(properties);
                this.updateStockUI(result);
            }, delay);
        }
    };

    /**
     *
     * The callback or shopify's "OptionSelectors" function
     * This runs when a variant is selected on a product page
     * It changes the stock status and price if the variant has diff prices
     * Also toggles the slider images to change
     *
     */
    var selectCallback = function (variant, selector) {
        // console.log('🎯 Main product page selectCallback called with:', {
        //     variant: variant
        //         ? {
        //               id: variant.id,
        //               title: variant.title,
        //               option1: variant.option1,
        //               option2: variant.option2,
        //               option3: variant.option3,
        //           }
        //         : null,
        //     selector: selector ? selector.id : null,
        // })

        // Get ALL buttons with name="add" on the page, not just in current scope
        var allAddToCartBtns = document.querySelectorAll('button[name="add"]'),
            addToCartBtn = allAddToCartBtns[0], // First button for reference
            otherAddToCartBtns = Array.from(allAddToCartBtns).slice(1), // All other buttons
            productPrices = scope.querySelectorAll('[data-price]'),
            comparePrices = scope.querySelectorAll('[data-compare] s'),
            sellingPlanInput = scope.querySelector('[name="selling_plan"]'),
            stockIndicator = scope.querySelector('.stock-indicator')
        quantityInput = scope.querySelector('input[name="quantity"]')
        productAvailabilityNotice = scope.querySelector(
            '.js-availability-notice '
        )

        currentVariant = variant
        // console.log(variant);

        var productAvailability, productVariant

        if (productAvailabilityNotice) {
            ;(productAvailability =
                productAvailabilityNotice.querySelector('.js-availablilty')),
                (productVariant =
                    productAvailabilityNotice.querySelector('.js-varient'))
        }

        if (!addToCartBtn) {
            return
        }

        // Reset Quantity input field & availability notice
        quantityInput.value = 1
        productAvailabilityNotice?.classList.add('disabled')

        if (variant) {
            _updateIDInput(allAddToCartBtns, variant)

            // Handle variant image switching with retry mechanism
            function attemptVariantImageSwitch() {
                // console.log('🎨 Variant image switching check:', {
                //     windowSlidersExists: typeof window.sliders !== 'undefined',
                //     productSliderExists:
                //         window.sliders && window.sliders['product-slider'],
                //     variantId: variant.id,
                // })

                // Try to find the slider directly if not in window.sliders
                let mainSlider =
                    window.sliders && window.sliders['product-slider']
                if (!mainSlider) {
                    // Try to find the slider by class
                    const sliderElement = document.querySelector(
                        '.product-hero-swiper'
                    )
                    if (sliderElement && sliderElement.swiper) {
                        mainSlider = sliderElement.swiper
                        // console.log('🎨 Found slider via element.swiper')
                    }
                }

                if (mainSlider) {
                    // console.log(
                    //     '🎨 Looking for variant image for variant ID:',
                    //     variant.id
                    // )
                    var thisImageSlide = scope
                        .closest('section')
                        .querySelector(`[data-variant-id*="${variant.id}"]`)

                    // console.log('🎨 Found image slide:', thisImageSlide)

                    if (thisImageSlide && thisImageSlide.dataset.slideIndex) {
                        var thisSlideTo = parseInt(
                            thisImageSlide.dataset.slideIndex
                        )
                        // console.log(
                        //     '🎨 Found variant image at slide index:',
                        //     thisSlideTo
                        // )

                        // Slide to the variant image with a small delay to ensure slider is ready
                        // Only auto-scroll on viewport 984px and above (desktop only)
                        if (window.innerWidth >= 984) {
                            setTimeout(() => {
                                try {
                                    // Account for loop offset - when loop is enabled, Swiper adds cloned slides
                                    // so we need to add the loop offset to get to the correct slide
                                    let slideIndex = thisSlideTo - 1 // Convert from 1-based to 0-based
                                    if (mainSlider.params.loop) {
                                        slideIndex += mainSlider.loopedSlides
                                    }
                                    mainSlider.slideTo(slideIndex)
                                    // console.log(
                                    //     '🎨 Successfully slid to variant image'
                                    // )
                                } catch (error) {
                                    console.error(
                                        '🎨 Error sliding to variant image:',
                                        error
                                    )
                                }
                            }, 100)
                        }

                        // Also update the thumbnail slider if it exists
                        if (window.productSliderNav) {
                            setTimeout(() => {
                                try {
                                    // For thumbnail slider, we don't need to account for loop offset
                                    // since it doesn't have loop enabled
                                    window.productSliderNav.slideTo(
                                        thisSlideTo - 1
                                    )
                                    // console.log(
                                    //     '🎨 Successfully updated thumbnail slider'
                                    // )
                                } catch (error) {
                                    console.error(
                                        '🎨 Error updating thumbnail slider:',
                                        error
                                    )
                                }
                            }, 100)
                        }

                        // Highlight the active thumbnail
                        _highlightActiveThumbnail(variant.id)
                    } else {
                        // console.log(
                        //     '🎨 No specific variant image found for variant ID:',
                        //     variant.id
                        // )
                        // console.log('🎨 Available slides with variant IDs:')
                        const allSlides = scope
                            .closest('section')
                            .querySelectorAll('[data-variant-id]')
                        // allSlides.forEach((slide, index) => {
                        //     console.log(
                        //         `  Slide ${index + 1}:`,
                        //         slide.dataset.variantId
                        //     )
                        // })
                    }
                } else {
                    // console.log(
                    //     '🎨 Slider not available for variant image switching, retrying...'
                    // )
                    // Retry after 500ms if slider is not available
                    setTimeout(attemptVariantImageSwitch, 500)
                }
            }

            // Only trigger variant image switching if this is a user interaction (not initial load)
            // We'll track this by checking if any radio buttons have been clicked
            const hasUserInteraction =
                scope.querySelector(
                    '.radio-selector input[type="radio"]:focus'
                ) ||
                scope.querySelector(
                    '.radio-selector input[type="radio"]:active'
                ) ||
                window.userHasInteractedWithVariants

            if (hasUserInteraction) {
                // This is a user interaction, trigger image switching
                attemptVariantImageSwitch()
            }
            // If it's initial load, we don't trigger image switching - let the slider stay on the first image

            var currentProduct
            if (scope != document && scope.classList.contains('modal')) {
                // currentProduct = currentQVItem;
            } else {
                currentProduct = product
            }

            if (
                currentProduct.variantStock &&
                currentProduct.variantStock[variant.id]
            ) {
                var currentStock =
                    currentProduct.variantStock[variant.id].inventory
            } else {
                // Fallback to variant's inventory_quantity if variantStock is not available
                var currentStock = variant.inventory_quantity || 0
            }

            // Availability Notice
            if (productAvailability) {
                productAvailability.textContent = currentStock
            }

            if (productVariant) {
                productVariant.textContent = variant.title
            }

            // addToCartbtn

            // Enough inventory OR Track quantity is unchecked OR Continue selling when out of stock is checked
            if (variant.available) {
                // Inventory >= 10 : In Stock
                if (currentStock >= 10) {
                    console.log('update meh 2')
                    console.log('update meh 2:', allAddToCartBtns)
                    _stockIndicator(stockIndicator, 'instock', currentStock)
                    productAvailabilityNotice?.classList.remove('invalid')
                }

                // Inventory > 0 : Low Stock
                else if (currentStock > 0) {
                    _stockIndicator(stockIndicator, 'lowstock', currentStock)
                    productAvailabilityNotice?.classList.remove('invalid')
                }

                // Track Quantity button is checked : Out of Stock
                else if (variant.inventory_management != null) {
                    _stockIndicator(stockIndicator, 'outofstock', 0)
                    productAvailabilityNotice?.classList.add('invalid')
                }

                // Track Quantity button is unchecked : No notice
                else if (variant.inventory_management == null) {
                    _stockIndicator(stockIndicator, false, null)
                    productAvailabilityNotice?.classList.add('invalid')
                }

                removeDisabledAttribute(allAddToCartBtns)

                if (currentStock > 0 || variant.inventory_management == null) {
                    // Update all buttons to show "Add to Cart"
                    allAddToCartBtns.forEach((btn) => {
                        if (!btn.dataset.originalText) {
                            btn.textContent = window.inventory_text.add_to_cart
                        }
                    })
                } else {
                    // Update all buttons to show "Pre-order"
                    allAddToCartBtns.forEach((btn) => {
                        if (!btn.dataset.originalText) {
                            btn.textContent = window.inventory_text.pre_order
                        }
                    })
                }

                // 0 inventory AND Track Quantity is Checked AND Continue selling when out of stock is unchecked
            } else {
                addDisabledAttribute(allAddToCartBtns)

                _stockIndicator(stockIndicator, 'outofstock', 0)
                productAvailabilityNotice?.classList.add('invalid')
            }

            // Prices
            productPrices.forEach((productPrice) => {
                // console.log('Updating price:', {
                //     variantPrice: variant.price,
                //     moneyFormat: window.money_format,
                // })
                productPrice.innerHTML = window.formatMoney(
                    variant.price,
                    window.money_format
                )

                productPrice.setAttribute('data-price', variant.price)
            })

            // Compare prices
            // console.log('Compare price check:', {
            //     variantComparePrice: variant.compare_at_price,
            //     variantPrice: variant.price,
            //     hasComparePrice:
            //         variant.compare_at_price &&
            //         variant.compare_at_price > variant.price,
            // })

            if (
                variant.compare_at_price &&
                variant.compare_at_price > variant.price
            ) {
                // console.log('Showing compare price')
                comparePrices.forEach(function (comparePrice) {
                    // console.log('Compare price element:', comparePrice)
                    comparePrice.innerHTML = window.formatMoney(
                        variant.compare_at_price,
                        window.money_format
                    )
                    const compareContainer =
                        comparePrice.closest('[data-compare]')
                    // console.log('Compare container:', compareContainer)
                    if (compareContainer) {
                        compareContainer.style.display = 'flex'
                    }
                })

                // Calculate and update saved amount
                const savedAmount = variant.compare_at_price - variant.price
                // console.log('Saved amount:', savedAmount)
                const savedAmountElements =
                    document.querySelectorAll('.saved-amount')
                // console.log('Saved amount elements:', savedAmountElements)
                savedAmountElements.forEach((el) => {
                    el.textContent = window.formatMoney(
                        savedAmount,
                        window.money_format
                    )
                })
            } else {
                // console.log('Hiding compare price')
                comparePrices.forEach(function (comparePrice) {
                    const compareContainer =
                        comparePrice.closest('[data-compare]')
                    if (compareContainer) {
                        compareContainer.style.display = 'none'
                    }
                })
            }
        } else {
            addDisabledAttribute(allAddToCartBtns)

            _stockIndicator(stockIndicator, 'outofstock')
            productAvailabilityNotice?.classList.add('invalid')
        }
    }

    // Simplified Bundle Handling - Show All Sizes Regardless of Inventory
    function handleSimpleBundlesSimplified() {
        // Only run on bundle product pages
        if (!document.body.classList.contains('template-productbundle-product-infinite')) {
            return false
        }

        setTimeout(() => {
            const cartForm = document.querySelector('form#add-to-cart')
            const simpleBundle = cartForm?.querySelector('#simple-bundles-io-options')

            if (!simpleBundle) return

            simpleBundle.classList.add('hidden')
            const selects = simpleBundle?.querySelectorAll('select')
            if (selects?.length === 0) return

            // Build replacement with simplified approach
            let radioButtonsWrapper = '<div class="flex flex-col gap-6 simple-bundle-options-radio">'

            // Group selects by product name prefix
            const productGroups = new Map()

            selects.forEach((selectBox, index) => {
                const label = document.querySelector(`label[for="${selectBox.id}"]`)
                let type = ''
                if (label) {
                    type = _slugify(label.textContent)
                } else {
                    type = 'option'
                }

                // Check for size options
                const isSize = type === 'size' ||
                    selectBox.name === 'properties[Size]' ||
                    (label && label.textContent && label.textContent.toLowerCase().includes('size'))

                // Extract product name (simplified - no need for handles)
                let productName = 'Product'
                if (label && label.textContent) {
                    const labelText = label.textContent.trim()
                    const productMatch = labelText.match(/^([^:]+):/)
                    if (productMatch) {
                        productName = productMatch[1].trim()
                    } else {
                        // If no colon, use the whole label minus common option words
                        productName = labelText.replace(/\s*(size|color|style|option)\s*$/i, '').trim()
                    }
                }

                if (!productGroups.has(productName)) {
                    productGroups.set(productName, [])
                }
                productGroups.get(productName).push({
                    selectBox,
                    label,
                    type,
                    isSize,
                    productName
                })
            })

            // Process each product group
            productGroups.forEach((selectsInGroup, productName) => {
                let productGroupHTML = `<div class="bundle-product-group" data-product-name="${_slugify(productName)}">`
                productGroupHTML += `<h4 class="text-lg font-bold text-[#091f2d] mb-3 uppercase tracking-wide font-['Anton'] border-b border-[#d7d7d7] pb-2 flex items-center gap-2">
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="7.27055" cy="6.78654" r="6.61454" fill="#00AEEF"/>
                        <path d="M6.48738 7.50905L9.54027 4.66185C9.81763 4.40318 10.2673 4.40314 10.5447 4.66185C10.8221 4.92056 10.8221 5.33998 10.5447 5.59865L6.98962 8.91425C6.71219 9.17299 6.26248 9.17289 5.98515 8.91425L4.00016 7.06297C3.72277 6.80426 3.72277 6.38485 4.00016 6.12617C4.27756 5.8675 4.72726 5.86746 5.00462 6.12617L6.48738 7.50905Z" fill="white"/>
                    </svg> 
                    ${productName}
                </h4>`

                selectsInGroup.forEach((selectData, index) => {
                    const { selectBox, label, type, isSize, productName } = selectData

                    if (isSize) {
                        // Create simplified size select (no inventory data needed)
                        productGroupHTML += createSimplifiedSizeSelectHTML(selectBox, 'Size')
                    } else {
                        // Convert to radio buttons
                        let selectOptions = Array.from(selectBox.querySelectorAll('option'))
                        let displayLabel = label.innerHTML

                        if (label.textContent) {
                            const labelText = label.textContent.trim()
                            const productMatch = labelText.match(/^([^:]+):\s*(.+)/)
                            if (productMatch) {
                                displayLabel = productMatch[2].trim()
                            }
                        }

                        productGroupHTML += `<label class="!mb-2 uppercase" style="font-family: 'Anton', sans-serif !important;">${displayLabel}</label>`
                        productGroupHTML += `<div class="flex flex-wrap gap-2 items-center radio-selector">`

                        selectOptions.forEach((option, optionIndex) => {
                            if (!option.value || option.value.trim() === '') return

                            let selected = false
                            if (option.selected || (optionIndex === 0 && !selectOptions.some(opt => opt.selected))) {
                                selected = true
                            }

                            productGroupHTML += `
                                <div class="flex w-max radio-selector__option">
                                    <input 
                                        id="${type}-${optionIndex}-bundle" 
                                        name="${selectBox.name}" 
                                        ${selected ? 'checked' : ''} 
                                        type="radio"
                                        class="hidden"
                                        value="${option.value}">
                                    <label 
                                        for="${type}-${optionIndex}-bundle" 
                                        class="variant-label ${_slugify(option.textContent)} rounded-lg overflow-hidden border border-[#D9D9D9] px-3 py-1 flex gap-2 items-center flex-nowrap w-max mr-2 mb-2"
                                        data-variant-id="">
                                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <circle cx="7.27055" cy="6.78654" r="6.61454" fill="#00AEEF"/>
                                            <path d="M6.48738 7.50905L9.54027 4.66185C9.81763 4.40318 10.2673 4.40314 10.5447 4.66185C10.8221 4.92056 10.8221 5.33998 10.5447 5.59865L6.98962 8.91425C6.71219 9.17299 6.26248 9.17289 5.98515 8.91425L4.00016 7.06297C3.72277 6.80426 3.72277 6.38485 4.00016 6.12617C4.27756 5.8675 4.72726 5.86746 5.00462 6.12617L6.48738 7.50905Z" fill="white"/>
                                        </svg>
                                        <span class="variant-option">${option.textContent}</span>
                                    </label>
                                </div>`
                        })

                        productGroupHTML += '</div>'
                    }
                })

                productGroupHTML += `</div>`
                radioButtonsWrapper += productGroupHTML
            })

            radioButtonsWrapper += '</div>'

            // Replace the bundle with simplified structure
            simpleBundle.insertAdjacentHTML('afterend', radioButtonsWrapper)

            // Set up simplified event handling with stock checking
            setupSimplifiedBundleEvents()

        }, 1000)

        return true
    }

    // Simplified bundle event setup with SKU-based stock checking
    function setupSimplifiedBundleEvents() {
        // Function to update checked styles
        function updateCheckedStyles(radioSelector) {
            let radioInputs = radioSelector.querySelectorAll('input[type="radio"]')
            radioInputs.forEach((radioInput) => {
                let label = radioInput.nextElementSibling
                if (label && label.classList.contains('variant-label')) {
                    if (radioInput.checked) {
                        label.style.borderColor = '#00aeef'
                        label.style.boxShadow = '0px 8.5px 26px 0px rgba(0,0,0,0.15)'
                    } else {
                        label.style.borderColor = '#D9D9D9'
                        label.style.boxShadow = 'none'
                    }
                }
            })
        }

        // Handle radio button changes
        const radioSelectors = document.querySelectorAll('.simple-bundle-options-radio .radio-selector')
        radioSelectors.forEach((selector) => {
            updateCheckedStyles(selector)

            const options = selector.querySelectorAll('.radio-selector__option')
            options.forEach((option) => {
                option.addEventListener('click', (e) => {
                    const radioInput = option.querySelector('input')

                    // Update selection
                    options.forEach((opt) => opt.classList.remove('active'))
                    radioInput.checked = true
                    option.classList.add('active')

                    // Update styling
                    updateCheckedStyles(selector)

                    // Set user interaction flag
                    window.userHasInteractedWithVariants = true

                    // Update bundle variant ID
                    updateSimplifiedBundleVariantId()

                    // CHECK STOCK - SKU-based approach
                    if (window.BundleStockChecker) {
                        window.BundleStockChecker.debounceStockCheck();
                    }
                })

                const radioInput = option.querySelector('input')
                radioInput.addEventListener('change', function () {
                    updateCheckedStyles(selector)
                    updateSimplifiedBundleVariantId()

                    // CHECK STOCK - SKU-based approach
                    if (window.BundleStockChecker) {
                        window.BundleStockChecker.debounceStockCheck();
                    }
                })
            })
        })

        // Handle size select changes
        const sizeSelects = document.querySelectorAll('.simple-bundle-options-radio select')
        sizeSelects.forEach(select => {
            select.addEventListener('change', () => {
                window.userHasInteractedWithVariants = true
                updateSimplifiedBundleVariantId()

                // CHECK STOCK - SKU-based approach
                if (window.BundleStockChecker) {
                    window.BundleStockChecker.debounceStockCheck();
                }
            })
        })

        // Add size guide event listeners
        const sizeGuideLinks = document.querySelectorAll('.simple-bundle-options-radio .size-guide-link')
        sizeGuideLinks.forEach((link) => {
            link.addEventListener('click', function (e) {
                e.preventDefault()
                var sizeGuideModal = document.getElementById('size-guide-modal')
                if (sizeGuideModal) {
                    if (typeof sizeGuideModal.showModal === 'function') {
                        sizeGuideModal.showModal()
                    } else {
                        sizeGuideModal.setAttribute('open', '')
                    }
                }
            })
        })

        // Initialize stock indicator colors for bundle products with stock checking
        setTimeout(() => {
            let stockIndicator = document.querySelector('.stock-indicator')
            if (stockIndicator && window.BundleStockChecker) {
                // Initial stock check
                window.BundleStockChecker.debounceStockCheck(100);
            }
        }, 100)
    }

    // Enhanced updateSimplifiedBundleVariantId function
    function updateSimplifiedBundleVariantId() {
        const cartForm = document.querySelector('form#add-to-cart')
        const idInput = cartForm?.querySelector('input[name="id"]')

        if (!idInput) return

        // Get all selected values from radio buttons and selects
        const selectedValues = []

        // Get radio button selections
        const radioInputs = document.querySelectorAll('.simple-bundle-options-radio input[type="radio"]:checked')
        radioInputs.forEach(input => {
            selectedValues.push(input.value)
        })

        // Get select selections
        const selectInputs = document.querySelectorAll('.simple-bundle-options-radio select')
        selectInputs.forEach(select => {
            if (select.value) {
                selectedValues.push(select.value)
            }
        })

        // Sync with original selects (let Simple Bundle handle the rest)
        const originalSelects = document.querySelectorAll('select[name^="properties"]')
        originalSelects.forEach(select => {
            const matchingValue = selectedValues.find(value =>
                Array.from(select.options).some(option => option.value === value)
            )
            if (matchingValue && select.value !== matchingValue) {
                select.value = matchingValue
                select.dispatchEvent(new Event('change'))
            }
        })

        console.log('Bundle selections updated:', selectedValues)
    }

    // 1. Try bundles first (simplified approach with stock checking)
    if (handleSimpleBundlesSimplified()) {
        return // Exit early for bundle products
    }

    // 2. Handle regular products (uses shared utilities)
    if (document.querySelector('#' + selectorID)) {
        // console.log(
        //     '🔧 Initializing Shopify OptionSelectors for main product page'
        // )
        // console.log('📋 Product data:', product)
        // console.log('🎯 Selector ID:', selectorID)

        waitForShopify(() => {
            // console.log('✅ Shopify loaded, creating OptionSelectors')
            new Shopify.OptionSelectors(selectorID, {
                product: product,
                onVariantSelected: selectCallback,
                enableHistoryState: false,
            })
            // console.log('✅ OptionSelectors created successfully')
        })

        // allow custom inputs to change the generated <select>
        let allSelectorWrappers = scope.querySelectorAll('.selector-wrapper')

        /**
         *
         * This converts shopify's select boxes in to radio elements
         *
         */
        allSelectorWrappers.forEach((selectorWrapper, sIndex) => {
            let label = selectorWrapper.querySelector('label')
            let type = ''

            if (label) {
                type = _slugify(label.textContent)
            } else {
                // this is if there's only one type of variant, ie Color (no size)
                // Set scope
                type =
                    document.querySelector('#product-selectors').dataset.label
                label = document.createElement('label')
                label.textContent = type
                type = _slugify(type)
            }

            if (label) {
                let select = selectorWrapper.querySelector('select')
                let selectOptions = Array.from(
                    select.querySelectorAll('option')
                )

                // Skip converting size variants to radio buttons
                if (type === 'size') {
                    // Keep the original select element visible but style the label
                    select.style.display = 'block'

                    // Style the size label
                    if (label) {
                        label.textContent = `${label.textContent} `
                        label.className = "font-['Anton'] font-bold uppercase"
                    }

                    // Create outer wrapper container for the entire size selection area
                    const outerWrapper = document.createElement('div')
                    outerWrapper.style.display = 'flex'
                    outerWrapper.style.gap = '1rem'
                    outerWrapper.style.flexWrap = 'wrap'

                    // Create inner wrapper specifically for select and SVG with relative positioning
                    const selectWrapper = document.createElement('div')
                    selectWrapper.style.position = 'relative'
                    selectWrapper.style.width = 'max-content'

                    // Add placeholder option if it doesn't exist
                    if (!select.querySelector('option[value=""]')) {
                        const placeholderOption =
                            document.createElement('option')
                        placeholderOption.value = ''
                        placeholderOption.textContent = 'Select a size'
                        placeholderOption.disabled = true
                        select.insertBefore(
                            placeholderOption,
                            select.firstChild
                        )
                    }

                    // Ensure first real option is selected
                    setTimeout(() => {
                        const realOptions = Array.from(select.options).filter(
                            (option) => option.value !== ''
                        )
                        if (realOptions.length > 0) {
                            // Find the first selected option, or select the first available option
                            const selectedOption =
                                realOptions.find((option) => option.selected) ||
                                realOptions[0]

                            // Set both the value and selected attribute
                            select.value = selectedOption.value
                            realOptions.forEach(
                                (option) => (option.selected = false)
                            )
                            selectedOption.selected = true

                            // Trigger change event to update Shopify's variant system
                            select.dispatchEvent(new Event('change'))

                            // Double-check after a short delay to ensure selection stuck
                            setTimeout(() => {
                                if (
                                    select.value === '' ||
                                    select.value === selectedOption.value
                                ) {
                                    select.value = selectedOption.value
                                    select.dispatchEvent(new Event('change'))
                                }
                            }, 100)
                        }
                    }, 0)

                    // Style the select element
                    select.style.paddingLeft = '2.5rem'
                    select.style.border = '1px solid #d1d5db'
                    select.style.borderRadius = '0.375rem'
                    select.style.padding = '0.5rem 2rem'
                    select.style.fontSize = '0.811rem'
                    select.style.width = '100%'
                    select.style.marginBottom = '0'

                    // Create and insert SVG into the select wrapper
                    const svgHTML = `<svg style="position: absolute; left: 0.75rem; top: 50%; transform: translateY(-50%); pointer-events: none; z-index: 20;" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="7.27055" cy="6.78654" r="6.61454" fill="#00AEEF"/>
<path d="M6.48738 7.50905L9.54027 4.66185C9.81763 4.40318 10.2673 4.40314 10.5447 4.66185C10.8221 4.92056 10.8221 5.33998 10.5447 5.59865L6.98962 8.91425C6.71219 9.17299 6.26248 9.17289 5.98515 8.91425L4.00016 7.06297C3.72277 6.80426 3.72277 6.38485 4.00016 6.12617C4.27756 5.8675 4.72726 5.86746 5.00462 6.12617L6.48738 7.50905Z" fill="white"/>
</svg>`

                    // Insert SVG into the select wrapper
                    selectWrapper.insertAdjacentHTML('beforeend', svgHTML)

                    // Move the select into the select wrapper, then into outer wrapper
                    select.parentNode.insertBefore(outerWrapper, select)
                    selectWrapper.appendChild(select)
                    outerWrapper.appendChild(selectWrapper)

                    // add type class to selector
                    selectorWrapper.classList.add('type-' + type)
                    selectorWrapper.classList.add('flex', 'flex-col', 'gap-2')

                    // Update size guide link positioning to be inside the flex container
                    if (!outerWrapper.querySelector('.size-guide-link')) {
                        let sizeGuideLink = document.createElement('a')
                        sizeGuideLink.href = '#'
                        sizeGuideLink.innerHTML =
                            '<svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_3259_27407)"><path d="M8 14.7866C11.3137 14.7866 14 12.1003 14 8.78656C14 5.47285 11.3137 2.78656 8 2.78656C4.68629 2.78656 2 5.47285 2 8.78656C2 12.1003 4.68629 14.7866 8 14.7866Z" stroke="#404040" stroke-linecap="round" stroke-linejoin="round"/><path d="M7.5 8.28656C7.63261 8.28656 7.75979 8.33924 7.85355 8.33301C7.94732 8.52677 8 8.65395 8 8.78656V11.2866C8 11.4192 8.05268 11.5463 8.14645 11.6401C8.24021 11.7339 8.36739 11.7866 8.5 11.7866" stroke="#404040" stroke-linecap="round" stroke-linejoin="round"/><path d="M7.75 6.78656C8.16421 6.78656 8.5 6.45077 8.5 6.03656C8.5 5.62235 8.16421 5.28656 7.75 5.28656C7.33579 5.28656 7 5.62235 7 6.03656C7 6.45077 7.33579 6.78656 7.75 6.78656Z" fill="#404040"/></g><defs><clipPath id="clip0_3259_27407"><rect width="16" height="16" fill="white" transform="translate(0 0.78656)"/></clipPath></defs></svg> See sizing guide'
                        sizeGuideLink.className =
                            'flex gap-1 items-center ml-2 text-sm font-normal leading-normal underline uppercase cursor-pointer shrink-0 size-guide-link text-neutral-700 hover:text-[#00AEEF]'
                        outerWrapper.appendChild(sizeGuideLink)

                        // Attach the event listener
                        sizeGuideLink.addEventListener('click', function (e) {
                            e.preventDefault()
                            var sizeGuideModal =
                                document.getElementById('size-guide-modal')
                            if (sizeGuideModal) {
                                if (
                                    typeof sizeGuideModal.showModal ===
                                    'function'
                                ) {
                                    sizeGuideModal.showModal()
                                } else {
                                    sizeGuideModal.setAttribute('open', '')
                                }
                            }
                        })
                    }
                    return
                }

                let radioButtonsHTML = `<label  class="font-['Anton'] uppercase ${type === 'size' ? 'text-lg uppercase' : ''}">${type}</label><div class="flex flex-wrap gap-2 radio-selector">`
                selectOptions.forEach((option, index) => {
                    let customColour = ''

                    if (variant_colours) {
                        variant_colours.forEach((item, vIndex) => {
                            let thisSplit = item.split(':')
                            let thisColour = thisSplit[0]
                            let colour = option.textContent
                                .replace(/\s+/g, '-')
                                .toLowerCase()

                            if (colour === thisColour) {
                                customColour = `color:${thisSplit[1]};`
                            }
                        })
                    }

                    let selected = false

                    if (option.selected) {
                        selected = true
                    }
                    // Always select the first option if no option is currently selected
                    if (
                        index === 0 &&
                        !selectOptions.some((opt) => opt.selected)
                    ) {
                        selected = true
                    }

                    // Check if the product passed in, is an upsell and assign unique IDs
                    // Else, no need to assign unqiue IDs
                    if (isUpsellProduct) {
                        radioButtonsHTML += `
						<div class="flex w-max radio-selector__option">
							<input 
								id="${type}-${index}-${selectorID}" 
								name="${type}-radio" 
								${selected ? 'checked' : ''} 
								type="radio"
								value="${option.value}">
							
						</div>`
                    } else {
                        radioButtonsHTML += `
						<div class="flex w-max radio-selector__option">
							<input 
								id="${type}-${index}" 
								name="${type}-radio" 
								${selected ? 'checked' : ''} 
								type="radio"
                                class="hidden"
								value="${option.value}">
							<label 
								style="${customColour}" 
								for="${type}-${index}" 
								class="variant-label ${_slugify(option.textContent)} rounded-lg overflow-hidden border  border-[#D9D9D9] px-3 py-1 flex gap-2 items-center flex-nowrap w-max"
								data-variant-id="">
                                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="7.27055" cy="6.78654" r="6.61454" fill="#00AEEF"/>
<path d="M6.48738 7.50905L9.54027 4.66185C9.81763 4.40318 10.2673 4.40314 10.5447 4.66185C10.8221 4.92056 10.8221 5.33998 10.5447 5.59865L6.98962 8.91425C6.71219 9.17299 6.26248 9.17289 5.98515 8.91425L4.00016 7.06297C3.72277 6.80426 3.72277 6.38485 4.00016 6.12617C4.27756 5.8675 4.72726 5.86746 5.00462 6.12617L6.48738 7.50905Z" fill="white"/>
</svg>

								<span class="variant-option">${option.textContent}</span>
							</label>
						</div>`
                    }
                })

                selectorWrapper.insertAdjacentHTML(
                    'afterbegin',
                    radioButtonsHTML
                )
            }

            label.textContent = `${label.textContent} `

            if (
                type === 'color' &&
                label.closest('form').classList.contains('main-product-atc')
            ) {
                let newColorSpan = `<span class="dyn-color ms-2 text-capitalize"></span>`

                label.insertAdjacentHTML('beforeend', newColorSpan)
            }

            // Hide the original label to prevent duplicate labels
            label.style.display = 'none'

            // add type class to selector
            selectorWrapper.classList.add('type-' + type)
            selectorWrapper.classList.add('flex', 'flex-col', 'gap-2')
        })

        /**
         *
         * Sync the selling plans across the page with the hero selector
         *
         */
        let allSellingPlans = document.querySelectorAll(
            '.subscriptions__group input'
        )

        let subPlanInputs = document.querySelectorAll('.sub-sticky')

        if (subPlanInputs.length) {
            allSellingPlans.forEach((el, index) => {
                if (el.checked) {
                    subPlanInputs.forEach((spEl, spIndex) => {
                        spEl.value = el.value
                    })
                }

                el.addEventListener('change', function () {
                    if (el.checked) {
                        subPlanInputs.forEach((spEl, spIndex) => {
                            spEl.value = el.value
                        })
                    }
                })
            })
        }

        _syncRadios()
        _updateTotalPrice()
    }

    /**
     *
     * This links the new radio buttons to shopify's select boxes
     * Changing a radio button, changes the select box and triggers the 'change' event
     * (Then, in shopify's script, not here, that 'change' event also changes the other hidden variant select option which triggers the callback function above)
     *
     */
    function _syncRadios() {
        let allRadioSelectors = [...scope.querySelectorAll('.radio-selector')]

        if (!isUpsellProduct) {
            let firstColor = scope.querySelector(
                '.type-color .radio-selector input:checked'
            )

            let dynColor = document.querySelector('.dyn-color')

            if (firstColor && dynColor) {
                dynColor.textContent = firstColor.value
            }
        }

        // Function to update checked styles
        function updateCheckedStyles() {
            allRadioSelectors.forEach((radioSelector) => {
                let radioInputs = radioSelector.querySelectorAll(
                    'input[type="radio"]'
                )
                radioInputs.forEach((radioInput) => {
                    let label = radioInput.nextElementSibling
                    if (label && label.classList.contains('variant-label')) {
                        if (radioInput.checked) {
                            // Add checked styles
                            label.style.borderColor = '#00aeef'
                            label.style.boxShadow =
                                '0px 8.5px 26px 0px rgba(0,0,0,0.15)'
                        } else {
                            // Remove checked styles
                            label.style.borderColor = '#D9D9D9'
                            label.style.boxShadow = 'none'
                        }
                    }
                })
            })
        }

        // Initial style update
        updateCheckedStyles()

        allRadioSelectors.forEach((radioSelector) => {
            let radioInputs = radioSelector.querySelectorAll(
                'input[type="radio"]'
            )

            radioInputs.forEach((radioInput) => {
                radioInput.addEventListener('change', function () {
                    // Set flag to indicate user has interacted with variants
                    window.userHasInteractedWithVariants = true

                    let selectedValue = this.value
                    let selectElement =
                        this.closest('.selector-wrapper').querySelector(
                            'select'
                        )

                    if (selectElement) {
                        selectElement.value = selectedValue
                        selectElement.dispatchEvent(new Event('change'))
                    }

                    // Update checked styles when radio changes
                    updateCheckedStyles()

                    // Syncs the upsell selected options to match the main product product when an option is selected on the main product.
                    _syncUpsellOptionsToMain(this)

                    // Swap out the featured image for the image that matches the correct color variant only on the upsells.
                    _fetchAndReplaceUpsellImage(radioInput)

                    // Update dynamic color name.
                    _dynNameColor(radioInput)

                    // Hide/Show product hero slide images based on the color selected.
                    // _imageColorMatch(radioInput)

                    // Update total price as the options are selected.
                    _updateTotalPrice()
                })

                // Also add user interaction flag to size select elements
                const sizeSelects = scope.querySelectorAll(
                    'select[name*="Size"], select[name*="size"]'
                )
                sizeSelects.forEach((sizeSelect) => {
                    sizeSelect.addEventListener('change', function () {
                        window.userHasInteractedWithVariants = true
                    })
                })
            })
        })
    }

    function _syncUpsellOptionsToMain(currentRadioInputTarget) {
        if (!initUpsellVariantSync) return

        let allUpsellRadios = [
            ...closestSection.querySelectorAll(
                '.product-upsell-card .radio-selector input[type="radio"]'
            ),
        ]

        if (allUpsellRadios.length === 0) return

        allUpsellRadios.forEach((radio) => {
            if (radio.value === currentRadioInputTarget.value) {
                radio.click()
            }
        })
    }

    function _fetchAndReplaceUpsellImage(currentRadioInput) {
        if (
            !isUpsellProduct ||
            currentRadioInput.getAttribute('name') != 'color-radio'
        )
            return

        let upsellCard = scope.closest('.product-upsell-card')
        let featureImage = upsellCard.querySelector(
            '.product-upsell-card__feature-img img'
        )
        let newFeatureImageSrc = currentVariant.featured_image.src

        // Check if the upsell card & feature image elements exist
        // Also, check if the selected variant has an image
        if (!upsellCard || !featureImage || !newFeatureImageSrc) return

        // Update both src & srcset. Also, add timestamp on each request to minimise caching issues.
        featureImage.src = `${newFeatureImageSrc}?crop=center&height=181&width=172&t=${new Date().getTime()}`
        featureImage.srcset = `${newFeatureImageSrc}?crop=center&height=181&width=172&t=${new Date().getTime()}`
    }

    function _dynNameColor(currentRadioInput) {
        if (
            isUpsellProduct ||
            currentRadioInput.getAttribute('name') != 'color-radio'
        )
            return

        document.querySelector('.dyn-color').textContent =
            currentRadioInput.value
    }

    function _mobileNavigateToTop(currentRadioInput) {
        if (
            !isUpsellProduct &&
            currentRadioInput.getAttribute('name') === 'color-radio' &&
            window.innerWidth < 768
        ) {
            window.scrollTo({
                top: 0,
                behavior: 'smooth',
            })
        }
    }

    // TODO: Ensure the global variables are only initialised on the product page.
    // Solution: Check if the closest section element contains 'section-producthero'.
    if (!isUpsellProduct) {
        /*
            On product page load, the original slides are stored in memory to ensure
            we can reference them when updating or removing the slide elements.
        */
        window.productSliderSlides = []
        window.navSliderSlides = []
        window.mergedSlides = []

        window.productSliderSlides = closestSection.querySelectorAll(
            '#product-slider .swiper-slide'
        )

        window.navSliderSlides = closestSection.querySelectorAll(
            '#product-slider-nav .swiper-slide'
        )

        window.mergedSlides = [
            ...window.productSliderSlides,
            ...window.navSliderSlides,
        ]
    }

    async function _imageColorMatch(currentRadioInput) {
        // If the script is called on a upsell product or the option selected isn't a color option. Return.
        if (
            isUpsellProduct ||
            currentRadioInput.getAttribute('name') != 'color-radio'
        )
            return

        // Target the swiper wrappers for both the product hero & control swipers.
        const productSliderWrapper = document.querySelector(
            '#product-slider .swiper-wrapper'
        )

        const navSliderWrapper = document.querySelector(
            '#product-slider-nav .swiper-wrapper'
        )

        // Destroy both swipers
        window.sliders['product-slider']?.destroy()
        window.productSliderNav?.destroy()

        // Re-populate both swipers with the all the original slide elements.
        for (const slide of window.productSliderSlides) {
            productSliderWrapper.insertAdjacentElement('beforeend', slide)
        }
        for (const slide of window.navSliderSlides) {
            navSliderWrapper.insertAdjacentElement('beforeend', slide)
        }

        // Init both swipers
        window.productSliderNav = window.newSwiper('#product-slider-nav', {
            speed: 600,
            loop: false,
            slidesPerView: 2,
            spaceBetween: 7,
            centeredSlides: false,
            slideToClickedSlide: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
            controller: {},
            autoplay: false,
            breakpoints: {
                768: {
                    spaceBetween: 14,
                },
            },
        })

        window.sliders['product-slider'] = await window.newSwiper(
            '#product-slider',
            {
                speed: 600,
                loop: false,
                slideToClickedSlide: true,
                spaceBetween: 20,
                slidesPerView: 1,
                navigation: {
                    nextEl: closestSection.querySelector('.swiper-next'),
                    prevEl: closestSection.querySelector('.swiper-prev'),
                },
                thumbs: {
                    swiper: window.productSliderNav,
                },
            }
        )

        // Loop through all slides(main & controller) and remove the slides that doesn't match the color selected.
        for (const slide of window.mergedSlides) {
            let slideImage = slide.querySelector('img')

            if (slideImage.alt && slideImage.alt !== currentRadioInput.value) {
                slide.remove()
            }
        }

        // Update the swiper so swiperjs can re-evualte the indexing of each slide.
        window.sliders['product-slider'].update()
        // window.sliders['product-slider'].thumbs.swiper.update();
    }

    function _updateTotalPrice() {
        if (!closestSection) return

        let totalPriceEl = closestSection.querySelector(
            '#upsell-complete-price'
        )
        if (!totalPriceEl) return

        let allPriceEls = [...closestSection.querySelectorAll('[data-price]')]

        // Get all the price values and convert to Integer
        let allPriceValues = allPriceEls.map((priceEl) =>
            Number(priceEl.getAttribute('data-price'))
        )

        // Get the sum
        let totalPrice = allPriceValues.reduce(
            (accumulator, currentValue) => accumulator + currentValue,
            0
        )

        // Format the new total
        let totalPriceFormatted = window.formatMoney(
            totalPrice,
            window.money_format
        )

        totalPriceEl.textContent = totalPriceFormatted
    }

    /**
     * Highlights the active thumbnail based on the current variant
     */
    function _highlightActiveThumbnail(variantId) {
        const thumbnailSlides = document.querySelectorAll(
            '#product-slider-nav .swiper-slide'
        )

        // Remove active class from all thumbnails
        thumbnailSlides.forEach((slide) => {
            slide.classList.remove('active-thumbnail')
        })

        // Add active class to the thumbnail that matches the variant
        thumbnailSlides.forEach((slide) => {
            const slideVariantId = slide.getAttribute('data-variant-id')
            if (
                slideVariantId &&
                slideVariantId.includes(variantId.toString())
            ) {
                slide.classList.add('active-thumbnail')
            }
        })
    }

    // Initialize stock indicator colors on page load
    if (scope.classList.contains('main-product-atc')) {
        setTimeout(() => {
            let stockIndicator = scope.querySelector('.stock-indicator')
            if (stockIndicator) {
                // Get the current status from the class
                let currentStatus = null
                if (stockIndicator.classList.contains('instock')) {
                    currentStatus = 'instock'
                } else if (stockIndicator.classList.contains('lowstock')) {
                    currentStatus = 'lowstock'
                } else if (stockIndicator.classList.contains('outofstock')) {
                    currentStatus = 'outofstock'
                }

                // Apply the appropriate color
                if (currentStatus) {
                    _stockIndicator(stockIndicator, currentStatus)
                }
            }
        }, 100) // Small delay to ensure DOM is ready
    }

    // Ensure first option is selected by default if none are selected
    if (scope.classList.contains('main-product-atc')) {
        let allRadioSelectors = scope.querySelectorAll('.radio-selector')
        allRadioSelectors.forEach((selector) => {
            let radioInputs = selector.querySelectorAll('input[type="radio"]')
            let hasChecked = Array.from(radioInputs).some(
                (input) => input.checked
            )

            // If no radio is checked, check the first one
            if (!hasChecked && radioInputs.length > 0) {
                radioInputs[0].checked = true
                // Trigger change event to update the corresponding select
                let selectElement = selector
                    .closest('.selector-wrapper')
                    .querySelector('select')
                if (selectElement) {
                    selectElement.value = radioInputs[0].value
                    selectElement.dispatchEvent(new Event('change'))
                }
            }
        })
    }

    // Initialize all buttons with name="add" on page load
    if (scope.classList.contains('main-product-atc')) {
        setTimeout(() => {
            const allAddToCartBtns =
                document.querySelectorAll('button[name="add"]')
            // console.log(
            //     'Found',
            //     allAddToCartBtns.length,
            //     'buttons with name="add" on page load'
            // )

            // Check if any variant is currently out of stock
            const selectedVariant =
                product.variants.find((v) => v.id == currentVariant?.id) ||
                product.selected_or_first_available_variant

            if (selectedVariant && !selectedVariant.available) {
                // console.log(
                //     'Current variant is out of stock, updating all buttons'
                // )
                addDisabledAttribute(allAddToCartBtns)
            }
        }, 200) // Small delay to ensure all buttons are rendered

        // Set up a mutation observer to watch for new buttons being added
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                mutation.addedNodes.forEach((node) => {
                    if (node.nodeType === 1) {
                        // Element node
                        const newButtons = node.querySelectorAll
                            ? node.querySelectorAll('button[name="add"]')
                            : []
                        if (newButtons.length > 0) {
                            // console.log(
                            //     'Found',
                            //     newButtons.length,
                            //     'new buttons with name="add"'
                            // )
                            // Check if current variant is out of stock and update new buttons
                            if (selectedVariant && !selectedVariant.available) {
                                addDisabledAttribute(Array.from(newButtons))
                            }
                        }
                    }
                })
            })
        })

        // Start observing the document for new buttons
        observer.observe(document.body, {
            childList: true,
            subtree: true,
        })
    }

    // Expose simplified bundle functions globally
    window.handleSimpleBundlesSimplified = handleSimpleBundlesSimplified
    window.setupSimplifiedBundleEvents = setupSimplifiedBundleEvents
    window.updateSimplifiedBundleVariantId = updateSimplifiedBundleVariantId

    // Debug helper functions for testing
    window.debugBundleStock = function() {
        if (!window.BundleStockChecker) {
            console.error('BundleStockChecker not loaded');
            return;
        }

        const properties = window.BundleStockChecker.getBundleProperties();
        console.log('Current bundle properties:', properties);

        if (Object.keys(properties).length === 0) {
            console.warn('No properties found - make sure you\'re on a bundle product page with selections made');
        } else {
            window.BundleStockChecker.checkBundleStock(properties)
                .then(result => console.log('Stock check result:', result))
                .catch(error => console.error('Stock check failed:', error));
        }
    };

    window.testBundleStockCheck = window.debugBundleStock; // Alias for backward compatibility
}